import { jsonReviver } from "./ajax.helpers"

export const getItem = <T>(key: string): T | undefined => {
    const item = sessionStorage.getItem(key)
    if (!item) return undefined

    try {
        return JSON.parse(item, jsonReviver) as T
    } catch (e) {
        console.error(`[getItem] Failed to parse key "${key}"`, e)
        return undefined
    }
}

export const setItem = <T>(key: string, value: T) => {
    sessionStorage.setItem(key, JSON.stringify(value))
}

export const removeItem = (key: string) => {
    sessionStorage.removeItem(key)
}
